import React from 'react'
import { BrowserRouter as Router } from 'react-router'
import StartQuiz from './StartQuiz'
import Quiz from './Quiz'
import { TranslationProvider } from '../shared/TranslationProvider'
import translations from './locales.json'
import { QuizProvider, useQuiz } from './QuizProvider'
import IdealWorkplaceEnvironmentResults from './QuizResults/IdealWorkplaceEnvironmentResults'
import PersonalBrandQuizResults from './QuizResults/PersonalBrandQuizResults'
import JobSearchQuizResults from './QuizResults/JobSearchQuizResults'
import JobSearchStrategyKnowledgeResults from './QuizResults/JobSearchStrategyKnowledgeResults'
import SpotSoftSkillResults from './QuizResults/SpotSoftSkillResults'
import ResumeReadyToImpressResults from './QuizResults/ResumeReadyToImpressResults'
import LinkedinAllStarResults from './QuizResults/LinkedinAllStarResults'
import CriticalThinkerResults from './QuizResults/CriticalThinkerResults'
import HowAdaptableResults from './QuizResults/HowAdaptableResults'
import BehavioralInterviewResults from './QuizResults/BehavioralInterviewResults'
import GoalSettingResults from './QuizResults/GoalSettingResults'
import AceTheInterviewResults from './QuizResults/AceTheInterviewResults'
import PortfolioCareerAptitudeResults from './QuizResults/PortfolioCareerAptitude'
import SelfEmploymentResults from './QuizResults/SelfEmploymentResults'
import StressManagementTacticsResults from './QuizResults/StressManagementTacticsResults'
import Questions from './Questions'
import { cn } from '~/lib/utils'
import OnboardingReadinessResults from './OnboardingReadiness/OnboardingReadinessResults'
import RetirementReadinessResults from './RetirementReadiness/RetirementReadinessResults'
import TaskCompletedModal from '../shared/TaskCompletedModal'

const Index = ({ locale, ...props }) => {
  return (
    <Router>
      <QuizProvider {...props} locale={locale}>
        <TranslationProvider
          locale={locale || 'en'}
          translations={translations}
          scope={'javascript.components.Quizzes'}
        >
          <QuizInner />
        </TranslationProvider>
      </QuizProvider>
    </Router>
  )
}
export default Index

export const QuizInner = () => {
  const { documentId, started, showResults } = useQuiz()
  const startPage = !started && !showResults
  const quizClasses = cn(
    !startPage && 'quiz flex justify-center border-l border-[#DDD] px-4 py-6',
  )
  return (
    // CTS-9282 — Plan 06 visual baseline: quiz shell / feedback capture root
    <div className={quizClasses} data-testid="resource-center-quiz">
      {showResults && <ResultsComponent />}
      {startPage && <StartQuiz quizExists={!!documentId} />}
      {started && !showResults && (
        <Quiz>
          <Questions />
        </Quiz>
      )}
    </div>
  )
}

const ResultsComponent = () => {
  const { quizName, resultsTasks, inActionPlan, locale } = useQuiz()

  let resultComponent = null

  if (quizName === 'Job Search') {
    resultComponent = <JobSearchQuizResults tasks={resultsTasks} />
  }
  if (quizName === 'Personal Brand Iq') {
    resultComponent = <PersonalBrandQuizResults tasks={resultsTasks} />
  }
  if (quizName === 'Job Search Strategy Knowledge') {
    resultComponent = <JobSearchStrategyKnowledgeResults tasks={resultsTasks} />
  }
  if (quizName === 'Spot Soft Skill') {
    resultComponent = <SpotSoftSkillResults tasks={resultsTasks} />
  }
  if (quizName === 'Ideal Workplace Environment') {
    resultComponent = <IdealWorkplaceEnvironmentResults tasks={resultsTasks} />
  }
  if (quizName === 'Resume Ready to Impress') {
    resultComponent = <ResumeReadyToImpressResults tasks={resultsTasks} />
  }
  if (quizName === 'Critical Thinker') {
    resultComponent = <CriticalThinkerResults />
  }
  if (quizName === 'LinkedIn All Star') {
    resultComponent = <LinkedinAllStarResults tasks={resultsTasks} />
  }
  if (quizName === 'How Adaptable') {
    resultComponent = <HowAdaptableResults />
  }
  if (quizName === 'Behavioral Interview Questions') {
    resultComponent = <BehavioralInterviewResults />
  }
  if (quizName === 'Goal Setting') {
    resultComponent = <GoalSettingResults />
  }
  if (quizName === 'Ace The Interview') {
    resultComponent = <AceTheInterviewResults />
  }
  if (quizName === 'Portfolio Career Aptitude') {
    resultComponent = <PortfolioCareerAptitudeResults />
  }
  if (quizName === 'Self Employment') {
    resultComponent = <SelfEmploymentResults />
  }
  if (quizName === 'Stress Management Tactics') {
    resultComponent = <StressManagementTacticsResults />
  }
  if (quizName === 'Onboarding Readiness') {
    resultComponent = <OnboardingReadinessResults />
  }
  if (quizName === 'Retirement Readiness') {
    resultComponent = <RetirementReadinessResults />
  }

  return (
    <>
      {resultComponent}
      {inActionPlan && <TaskCompletedModal open={true} locale={locale} />}
    </>
  )
}
